<template lang="pug">
	.campaign-overview.flex-col.space
		.flex-row.wrap.space
			.flex-row.wrap.space-large.justify.area.flex-4
				.flex-col.flex-1.space-medium
					.flex-2.flex-col
						.font-small.upper.grey {{$tCaption('Name')}}
						EditableLabel(ref="lblCampaignName", :editing="!campaign.Name", :disabled="info.readonly")
							span {{campaign.Name || $tCaption('Edit', '@actions')}}
							DxTextBox(slot="editor", :value.sync="campaign.Name", @value-changed="$refs.lblCampaignName.release()")
					.flex-col
						.font-small.upper.grey {{$tCaption('Advertiser')}}
						EditableLabel(ref="advertiserLabel", :disabled="$auth.isAdvertiser() || info.readonly", :editing="!campaign.Advertiser.Name")
							span {{campaign.Advertiser.Name || $tCaption('Edit', '@actions')}}
							Dropdown.full-width(ref="advertiser",
								slot="editor",
								v-model="campaign.Advertiser.Oid", 
								:preloadedObjects="[campaign.Advertiser]",
								:disabled="$auth.isAdvertiser()"
								:multiple="false", 
								:getData="(a,b,opts) => $Data.getExternalCompanies(a,b,{ ...(opts || {}), byType: 0 })", 
								:getItems="r => r.Results",
								:columns="[{ dataField: 'Name', caption: () => $tCaption('Name') }]",
								valueExpr="Oid",
								displayExpr="Name",
								@select-data="v => campaign.Advertiser = v || { Oid: null }"
								@opened="v => !v && $refs.advertiserLabel.release()")
					.flex-col
						.font-small.upper.grey {{$tCaption('Agency')}}
						EditableLabel(ref="agencyLabel", :disabled="$auth.isAgency() || info.readonly", :editing="!campaign.Agency.Name")
							span {{campaign.Agency.Name || $tCaption('Edit', '@actions')}}
							Dropdown(ref="agency",
								slot="editor",
								v-model="campaign.Agency.Oid",
								:preloadedObjects="[campaign.Agency]",
								:disabled="$auth.isAgency()"
								:multiple="false", 
								:getData="(a,b,opts) => $Data.getExternalCompanies(a,b,{ ...(opts || {}), byType: 2 })", 
								:getItems="r => r.Results",
								:columns="[{ dataField: 'Name', caption: () => $tCaption('Name') }]",
								valueExpr="Oid",
								displayExpr="Name",
								@select-data="v => campaign.Agency = v || { Oid: null }"
								@opened="v => !v && $refs.agencyLabel.release()")
					template(v-if="!info.isNew && info.fullAccess")
						.flex-col
							.font-small.upper.grey {{$tCaption('Industry')}}
							IabCategoriesSelector(ref="iabSelector", :objectId="campaign.Oid", :objectTypeId="$Data.objectTypes.Campaign", :parentCategoryCode="90", :disabled="info.readonly", @selected="v => $set(campaign, 'IabCategories', v)")
				.flex-col.flex-1.space-medium
					.flex-col(v-if="!info.isNew")
						.font-small.upper.grey {{$tCaption('Type')}}
						span {{campaignType.name}}
					.flex-col
						.font-small.upper.grey {{$tCaption('Start date')}}
						EditableLabel(ref="lblCampaignStartDate", :editing="!campaign.StartDate", :disabled="info.readonly")
							span {{$Data.formatDate(campaign.StartDate, 'YYYY-MM-DD') || $tCaption('Edit', '@actions')}}
							DxDateBox(slot="editor", :value.sync="campaign.StartDate", @value-changed="$refs.lblCampaignStartDate.release()")
					.flex-col
						.font-small.upper.grey {{$tCaption('End date')}}
						EditableLabel(ref="lblCampaignEndDate", :editing="!campaign.EndDate", :disabled="info.readonly")
							span {{$Data.formatDate(campaign.EndDate, 'YYYY-MM-DD') || $tCaption('Edit', '@actions')}}
							DxDateBox(slot="editor", :value.sync="campaign.EndDate", @value-changed="$refs.lblCampaignEndDate.release()")
			.flex-col(v-if="!info.wizard && campaign.PopulationStatistic && (campaign.PopulationStatistic.SelectedPopulation || campaign.PopulationStatistic.TotalPopulation) && info.fullAccess")
				.flex-col.clickable-area.space.area.flex-1.center.align-center.clickable(@click="$emit('navigate', 'audience')")
					.font-small.upper.grey {{$tCaption('Target audience size')}}
					.flex-row.space.align-center
						fas(icon="users")
						.font-big {{$Data.formatNumber(campaign.PopulationStatistic.SelectedPopulation || campaign.PopulationStatistic.TotalPopulation)}}
		template(v-if="info.type === 1 && !info.wizard && info.fullAccess")
			.area.flex-row.space-extralarge.align-center.align-right-editors.wrap
				.flex-col.align-end
					.font-small.upper.grey {{$tCaption('Air Time Spots')}}
					EditableLabel(ref="lblTotalTargetAirTimeSpots", :disabled="info.readonly")
						.font-big {{$Data.formatNumber(campaign.TotalTargetAirTimeSpots || 0)}}
						DxNumberBox(slot="editor", :value.sync="campaign.TotalTargetAirTimeSpots", @value-changed="$refs.lblTotalTargetAirTimeSpots.release()", :width="100")
				.flex-col.align-end
					.font-small.upper.grey {{$tCaption('Target GRPs')}}
					EditableLabel(ref="lblTotalTargetGrps", :disabled="info.readonly")
						.font-big {{$Data.formatNumber(campaign.TotalTargetGrps || 0)}}
						DxNumberBox(slot="editor", :value.sync="campaign.TotalTargetGrps", @value-changed="$refs.lblTotalTargetGrps.release()", :width="100")
				.flex-col.align-end
					.font-small.upper.grey {{$tCaption('Target Impressions')}}
					EditableLabel(ref="lblTotalTargetImpressions", :disabled="info.readonly")
						.font-big {{$Data.formatNumber(campaign.TotalTargetImpressions || 0)}}
						DxNumberBox(slot="editor", :value.sync="campaign.TotalTargetImpressions", @value-changed="$refs.lblTotalTargetImpressions.release()", :width="100")
				.flex-col.align-end
					.font-small.upper.grey {{$tCaption('Net Amount')}}
					EditableLabel(ref="lblNettAmount", :disabled="info.readonly")
						.font-big {{$Data.formatNumber(campaign.NettAmount || 0)}}
						DxNumberBox(slot="editor", :value.sync="campaign.NettAmount", @value-changed="$refs.lblNettAmount.release()", :width="100")
		template(v-if="!info.isNew")
			.flex-row.area.flex-1.flex-row.space.center.align-center(v-if="info.fullAccess")
				.flex-col.flex-1.space
					.font-small.upper.grey {{$tCaption('Keywords')}}
					EditableLabel(:editing="(!campaign.TargetKeywords || info.wizard) && !info.readonly", :disabled="info.readonly")
						.flex-row.space.wrap
							.adt-tag.nowrap.overflow.max-width-200.keyword-label(v-for="keyword in keywordsList") {{keyword}}
						template(slot="editor")
							CampaignKeywords.flex-1(v-if="info", :info="info", @industry-selected="onIndustrySelected")
			.flex-row.wrap.space.flex-1(v-if="!info.wizard")
				template(v-if="info.type === 1")
					.area.flex-3.flex-row.space.center.align-center.link-area.clickable-area.green(@click="() => $router.push({ path: `/logs/Airtime`, query: { campaignId: this.campaign.Oid } })")
						.flex-col.space
							fas.link-greyed(icon="tower-broadcast", size="xl")
							.link.upper {{$tCaption('Airtime log')}}
						.link-icon
							fas(icon="arrow-up-right-from-square")
					.area.flex-3.flex-row.space.center.align-center.link-area.clickable-area.blue(@click="() => $router.push({ path: `/logs/Dashboard`, query: { campaignId: this.campaign.Oid } })")
						.flex-col.space
							fas.link-greyed(icon="chart-line", size="xl")
							.link.upper {{$tCaption('Creative dashboard')}}
						.link-icon
							fas(icon="arrow-up-right-from-square")
				.area.flex-1.flex-row.space.center.align-center.link-area.clickable-area.delete-link.red(@click="$emit('delete-campaign')")
					.flex-col.space
						fas(icon="times", size="xl")
						.link.upper.nowrap {{info.type === 1 ? $tCaption('Delete campaign') : $tCaption('Delete proposal')}}
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxNumberBox from 'devextreme-vue/number-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import Loader from 'app-core/Loader.vue';
	import Dropdown from 'app-core/Dropdown.vue';
	import EditableLabel from 'app-core/EditableLabel.vue';
	import { CAMPAIGN_TYPES } from 'app-core/constants';
	import CampaignKeywords from './CampaignKeywords.vue';
	import IabCategoriesSelector from 'view/iabCategory/Selector.vue';

	export default {
		translationCategory: 'campaign.Detail',
		name: 'campaign-overview',
		components: {
			DxButton, DxTextBox, Loader, DxDateBox, Dropdown, EditableLabel, CampaignKeywords, IabCategoriesSelector, DxNumberBox
		},
		props: ['info'],
		data() {
			return {
				campaignTypes: CAMPAIGN_TYPES.toLocale('name', this)
			};
		},
		computed: {
			campaignType() {
				return this.campaignTypes[this.campaign?.CampaignType || 0];
			},
			campaign() {
				return this.info?.campaign;
			},
			keywordsList() {
				return `${this.campaign.TargetKeywords}`.split(',').map(f => `${f}`.trim()).filter(f => f);
			}
		},
		mounted() {
			if (__DEBUG__)
				window.campaignOverview = this;
		},
		methods: {
			onIndustrySelected(v) {
				if (!this.campaign?.iabCategories?.length) {
					this.$refs.iabSelector.selectByName(v);
				}
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.campaign-overview {
		.delete-link {
			color: #929292;

			&:hover {
				color: #ff4949;
			}
		}

		.keyword-label {
			margin-bottom: 6px;
		}
	}
</style>
 